// Module
var code = " <gb-button icon=\"add\" ng-click=\"$ctrl.addWidget()\"> <span translate=\"ADD_THERMOMETER_WIDGET_BUTTON\"></span> </gb-button> <gb-edit-thermometer-widget widget=\"$ctrl.getWidget()\"></gb-edit-thermometer-widget> ";
// Exports
export default code;